<router-outlet />
<app-toast [toasts]="notificationService.toasts()" (dismissed)="notificationService.dismiss($event)" />

@let confirmRequest = dialogService.confirmRequest();
<app-confirm-dialog
  [open]="confirmRequest !== null"
  [title]="confirmRequest?.title ?? ''"
  [message]="confirmRequest?.message ?? ''"
  [confirmLabel]="confirmRequest?.confirmLabel ?? 'Confirmar'"
  [cancelLabel]="confirmRequest?.cancelLabel ?? 'Cancelar'"
  [variant]="confirmRequest?.variant ?? 'default'"
  (confirmed)="dialogService.resolveConfirm(true)"
  (cancelled)="dialogService.resolveConfirm(false)"
/>

@let promptRequest = dialogService.promptRequest();
<app-prompt-dialog
  [open]="promptRequest !== null"
  [title]="promptRequest?.title ?? ''"
  [message]="promptRequest?.message ?? ''"
  [label]="promptRequest?.label ?? 'Motivo'"
  [placeholder]="promptRequest?.placeholder ?? ''"
  [allowEmpty]="promptRequest?.allowEmpty ?? false"
  [maxLength]="promptRequest?.maxLength ?? null"
  [initialValue]="promptRequest?.initialValue ?? ''"
  [confirmLabel]="promptRequest?.confirmLabel ?? 'Confirmar'"
  [cancelLabel]="promptRequest?.cancelLabel ?? 'Cancelar'"
  (confirmed)="dialogService.resolvePrompt($event)"
  (cancelled)="dialogService.resolvePrompt(null)"
/>
